import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {
    ACCORDION_VARIANTS,
    ACCORDION_HEADER_SIZES,
    ACCORDION_HEADER_WEIGHTS,
    ACCORDION_BACKGROUND_COLOURS,
} from '@ratehub/base-ui';

import HeadingPropTypes from '../definitions/HeadingPropTypes';
import HeadingBlock from './HeadingBlock';
import AccordionItem from './AccordionItem';


function FaqAccordion({
    heading,
    variant = ACCORDION_VARIANTS.DEFAULT,
    questions = [],
    size = ACCORDION_HEADER_SIZES.LARGE,
    weight = ACCORDION_HEADER_WEIGHTS.REGULAR,
    alwaysRenderChildMarkup = true,
    className,
    accordionBackgroundColour = ACCORDION_BACKGROUND_COLOURS.TRANSPARENT,
}) {
    const schema = {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        'mainEntity': questions.map(question => ({
            '@type': 'Question',
            'name': question.title,
            'acceptedAnswer': {
                '@type': 'Answer',
                'text': question.content,
            },
        })),
    };

    return (
        /* Matching rich text block - will be removed when we implement proper block width sizing */
        <div className={classNames(
            'rh-mx-auto rh-max-width-800px',
            className,
        )}
        >
            <script
                type="application/ld+json"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(schema, null, 4),
                }}
            />

            <HeadingBlock
                {...heading}
            />

            <For
                each="question"
                of={questions}
            >
                <AccordionItem
                    key={question.title}
                    alwaysRenderChildMarkup={alwaysRenderChildMarkup}
                    variant={variant}
                    size={size}
                    weight={weight}
                    accordionBackgroundColour={accordionBackgroundColour}
                    {...question}
                />
            </For>
        </div>
    );
}

FaqAccordion.propTypes = {
    heading: HeadingPropTypes,
    questions: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        content: PropTypes.string.isRequired,
    })),
    variant: PropTypes.oneOf(Object.values(ACCORDION_VARIANTS)),
    size: PropTypes.oneOf(Object.values(ACCORDION_HEADER_SIZES)),
    weight: PropTypes.oneOf(Object.values(ACCORDION_HEADER_WEIGHTS)),
    accordionBackgroundColour: PropTypes.oneOf(Object.values(ACCORDION_BACKGROUND_COLOURS)),
    alwaysRenderChildMarkup: PropTypes.bool,
    className: PropTypes.string,
};

FaqAccordion.hasHeading = true;
FaqAccordion.blockKey = 'rh/faq-accordion';
FaqAccordion.requiresLayoutRow = true;

export default FaqAccordion;
